import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import PageBanner from "../components/PageBanner";
import QuoteBand from "../components/QuoteBand";
import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import { applications, company } from "../mock";

export default function ApplicationDetail() {
  const { slug } = useParams();
  const app = applications.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!app) return <Navigate to="/uygulamalar" replace />;
  const others = applications.filter((a) => a.slug !== slug);
  const banners = [
    "/images/slider/slider1.jpg",
    "/images/slider/slider2.jpg",
    "/images/slider/slider3.jpg",
    "/images/slider/slider4.jpg",
    "/images/slider/slider5.jpg",
    "/images/slider/slider.jpg"
  ];
  const banner = banners[applications.findIndex((a) => a.slug === slug) % banners.length];

  return (
    <div className="bg-white" data-testid="application-detail-page">
      <PageBanner
        title={app.title}
        breadcrumbs={[{ label: "Uygulamalar", to: "/uygulamalar" }, { label: app.title }]}
        image={banner}
      />
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 lg:gap-20">
          <div className="lg:col-span-8">
            <Reveal>
              <div className="frame">
                <img src={app.image} alt={app.title} className="w-full h-[360px] lg:h-[440px] object-cover" />
              </div>
              <SectionHeading eyebrow="Uygulama" title={app.title} className="mt-14" />
              <div className="mt-8 space-y-5 text-[14.5px] text-brand-muted leading-[1.85] font-light max-w-2xl">
                {app.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              <ul className="mt-10 grid sm:grid-cols-2 gap-px bg-brand-line border border-brand-line">
                {["EN 1090-2 / AWS / TSE standartları", "%100 izlenebilirlik", "NDT kontrollü kaynaklar", "Zamanında teslimat"].map((b, i) => (
                  <li key={i} className="bg-white px-5 py-4 flex items-center gap-3 text-[13px] text-brand-ink font-medium">
                    <span className="font-mono text-[10px] text-brand-accent/60">{String(i + 1).padStart(2, "0")}</span>
                    {b}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
          <aside className="lg:col-span-4 space-y-px">
            <div className="border border-brand-line p-7">
              <h3 className="eyebrow text-brand-muted mb-6">Diğer Uygulamalar</h3>
              <ul className="space-y-px bg-brand-line-soft">
                {others.map((a) => (
                  <li key={a.slug}>
                    <Link
                      to={`/uygulama/${a.slug}`}
                      className="group bg-white flex items-center justify-between gap-3 py-3 px-1 text-brand-muted hover:text-brand-accent transition-colors duration-300"
                    >
                      <span className="text-[13px] font-light">{a.title}</span>
                      <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="grain relative bg-brand-ink p-8 text-white overflow-hidden">
              <div className="absolute inset-0 blueprint opacity-70" />
              <div className="relative">
                <h3 className="font-display text-lg font-light tracking-[-0.02em]">Projeniz mi var?</h3>
                <p className="mt-3 text-[13px] text-slate-500 font-light leading-relaxed">
                  Özel projeleriniz için hemen teklif alın veya bize ulaşın.
                </p>
                <a
                  href={company.phoneHref}
                  className="mt-6 flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.16em] bg-brand-accent hover:bg-brand-accent-light text-white px-5 py-3.5 rounded-full transition-colors duration-300"
                >
                  <Phone className="w-3.5 h-3.5" /> {company.phone}
                </a>
                <Link
                  to="/teklif-iste"
                  className="mt-3 flex items-center justify-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] border border-white/20 hover:bg-white hover:text-brand-ink text-white px-5 py-3.5 rounded-full transition-colors duration-300"
                >
                  Teklif İste
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </section>
      <QuoteBand />
    </div>
  );
}
